import { render, staticRenderFns } from "./oldRedirect.vue?vue&type=template&id=07824836&scoped=true&"
import script from "./oldRedirect.vue?vue&type=script&lang=js&"
export * from "./oldRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07824836",
  null
  
)

export default component.exports